import { JsonDiscriminatorProperty, JsonObject, JsonProperty } from "ta-json";

export type VisualSearchType = "vector" | "vector+text" | "text" | "vectorOrText" | "vectorAndText";

@JsonObject()
export class VisualSearchResource {
    /**
     * The color the user has selected in the color dropdown.
     */
    @JsonProperty("color")
    color?: string;

    /**
     * What the search should take into account ("image" | "imageAndMetaData" | "metaData").
     */
    @JsonProperty("type")
    type?: VisualSearchType;

    /**
     * The id of the asset that the user wants to find similar assets for.
     */
    @JsonProperty("imageEntityId")
    imageEntityId?: number;

    /**
     * Indicates if the search should be a deep search.
     */
    @JsonProperty("IsDeepSearch")
    isDeepSearch?: boolean;

    /**
     * The value for the AI search box.
     */
    @JsonProperty("text")
    text?: string;

    constructor(init?: Partial<VisualSearchResource>) {
        Object.assign(this, init);
    }
}

@JsonObject()
@JsonDiscriminatorProperty("image")
export class VisualSearchRequestResource extends VisualSearchResource {
    /**
     * The base64 hash of the image that the user uploaded to find similar assets for.
     */
    @JsonProperty("image")
    image?: string;

    constructor(init?: Partial<VisualSearchRequestResource>) {
        super(init);

        Object.assign(this, init);
    }
}
